export default __webpack_public_path__ + "static/media/SAS Alert Tone 19.6e3be7aa.wav";